import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as R from 'ramda'

import Panel from 'components/form/notebookPanel/index'
import { createNamedReducer } from 'helpers/ReducerUtil'
import panelReducer from './reducer'
import injectReducer from 'helpers/injectReducer'
import injectSagas from 'helpers/injectSagas'
import getSelectors from './selectors'
import {
  getActions
} from './actions'
import {
  loadSagas
} from './sagas'
import {
  getPath,
  combinePath
} from 'containers/Form/util'

const withReducer = (path, id) => {
  const valuePath = getPath(path, id)
  const reducer = createNamedReducer(valuePath, panelReducer)
  return injectReducer(valuePath, reducer)
}

const withConnect = (path, id) => {
  const combinedPath = combinePath(path, id)
  const valuePath = getPath(path, id)

  const {
    changeRefreshRateValue,
    changePartNumberValue,
    changeResolutionValue,
    changeSizeValue,
    changeVendorValue,
    addPanel,
    removePanel,
  } = getActions(valuePath)

  const {
    labelSelector,
    valuesSelector,
    vendorSourceSelector,
    sizeSourceSelector,
    resolutionSourceSelector,
    refreshRateSourceSelector,
  } = getSelectors(combinedPath)

  const mapStateToProps = (state) => {
    return {
      label: labelSelector(state),
      values: valuesSelector(state),
      vendorSource: vendorSourceSelector(state),
      sizeSource: sizeSourceSelector(state),
      resolutionSource: resolutionSourceSelector(state),
      refreshRateSource: refreshRateSourceSelector(state),
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      onRefreshRateChange: (index, value) => dispatch(changeRefreshRateValue(index, value)),
      onResolutionChange: (index, value) => dispatch(changeResolutionValue(index, value)),
      onSizeChange: (index, value) => dispatch(changeSizeValue(index, value)),
      onVendorChange: (index, value) => dispatch(changeVendorValue(index, value)),
      onPartNumberChange: (index, value) => dispatch(changePartNumberValue(index, value)),
      onAdd: () => dispatch(addPanel()),
      onRemove: (index) => dispatch(removePanel(index)),
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)
}

const withSaga = (path, id) => {
  const combinedPath = combinePath(path, id)
  const valuePath = getPath(path, id)
  const sagas = loadSagas(valuePath, combinedPath, id)

  return injectSagas({ [combinedPath]: sagas })
}

export { default as Panel } from 'components/form/notebookPanel/index'
export {
  withConnect,
  withReducer,
  withSaga,
}

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
  withConnect(path, id),
  withSaga(path, id)
)(Panel))
